;(function (angular, _) {
  'use strict'

  class LinkInterventionController {
    // DI
    $q
    $uibModal
    interventionManager
    invoiceLineManager
    displayService
    $state
    tokenSwitcherService
    urls
    // bindings
    interventions
    // locals
    interventionSelection
    stockSelection
    data = []
    allStocks = []
    loading = false

    constructor (
      // Angular
      $q, $state,
      // Libs
      $uibModal,
      // Managers
      InterventionManager, InvoiceLineManager,
      // Services
      DisplayService, SelectionService, TokenSwitcherService,
      // Const
      urls
      // Resolved
    ) {
      this.$q = $q
      this.$state = $state
      this.$uibModal = $uibModal
      this.invoiceLineManager = InvoiceLineManager
      this.interventionManager = InterventionManager
      this.displayService = DisplayService
      this.tokenSwitcherService = TokenSwitcherService
      this.urls = urls
      this.interventionSelection = SelectionService.getSelection()
      this.stockSelection = SelectionService.getSelection(function (a) { return a.intervention + a.stock._id })
    }

    $onInit () {
    }

    $onChanges (changes) {
      if (changes && changes.interventions) {
        this._loadInterventions(changes?.interventions?.currentValue || [])
      }
    }

    openInSoli (intervention) {
      return this._switchApp().then((token) => {
        window.open(`${this.urls.soli}/interventions/${intervention._id}#${token}`, '_blank')
      })
    }

    addIntervention () {
      return this.displayService.displayConfirm('Êtes vous sûr de vouloir quitter ?', 'Vous avez peut-être des modifications non sauvegardées')
        .then(() => {
          return this._switchApp()
        })
        .then((token) => {
          window.open(this.urls.soli + encodeURI(`/interventions/external-search?redirectUri=${this.$state.href(this.$state.current.name, this.$state.params, { absolute: true })}`) + '#' + token, '_self')
        })
    }

    removeIntervention (intervention) {
      return this.displayService.confirmDeletion().then(() => {
        this.remove({ $interventions: [intervention] })
      })
    }

    removeSelectedInterventions () {
      return this.remove({ $interventions: this.interventionSelection.selectedData })
    }

    invoiceSelected () {
      if (this.disabled) {
        return
      }
      const interventions = this.interventionSelection.selectedData
      const stocks = this.stockSelection.selectedData
      return this.$uibModal.open({
        controllerAs: 'selectProduct',
        bindToController: true,
        templateUrl: '/app/modules/invoice/show/templates/invoice-show-from-soli.html',
        controller: 'SelectProduct',
        resolve: { interventions: _.constant(interventions), stocks: _.constant(stocks) }
      }).result.then(({ travel, sum, product, productTravel, stocks }) => {
        let lines = []

        function getQuantityFromIntervention (intervention, key) {
          let realKey
          switch (key.toLowerCase()) {
            case 'real':
              if (_.get(intervention, 'durations.correctedWithoutPause')) {
                realKey = 'durations.correctedWithoutPause'
              } else {
                realKey = 'durations.withoutPause'
              }
              break
            case 'travel':
              if (_.get(intervention, 'durations.correctedTravel')) {
                realKey = 'durations.correctedTravel'
              } else {
                realKey = 'durations.travel'
              }
              break
          }
          const qte = Math.trunc(_.get(intervention, realKey) / 36000) / 100
          return qte === 0 ? 1 : qte
        }

        if (interventions.length) {
          if (!sum) {
            lines = interventions.reduce((acc, inter) => {
              const line = this.invoiceLineManager.create({
                product: product._id,
                label: product.label,
                reference: product.reference,
                description: product.description,
                price: product.price,
                VAT: product.VAT,
                unit: product.unit,
                quantity: getQuantityFromIntervention(inter, 'real'),
                type: 'simple_line',
                shouldRecompute: true
              })
              line.intervention = inter
              acc.push(line)
              if (travel) {
                var l = this.invoiceLineManager.create({
                  product: _.get(productTravel, '_id'),
                  label: _.get(productTravel, 'label', 'Déplacement'),
                  reference: _.get(productTravel, 'reference'),
                  description: _.get(productTravel, 'description'),
                  price: _.get(productTravel, 'price'),
                  VAT: _.get(productTravel, 'VAT'),
                  unit: _.get(productTravel, 'unit'),
                  quantity: getQuantityFromIntervention(inter, 'travel'),
                  type: 'simple_line',
                  shouldRecompute: true
                })
                l.intervention = inter
                l.travel = true
                acc.push(l)
              }
              return acc
            }, [])
          } else {
            const totals = interventions.reduce(function (acc, inter) {
              acc.duration += getQuantityFromIntervention(inter, 'real')
              acc.travel += getQuantityFromIntervention(inter, 'travel')
              return acc
            }, { travel: 0, duration: 0 })
            lines = [this.invoiceLineManager.create({
              product: product._id,
              label: product.label,
              reference: product.reference,
              description: product.description,
              price: product.price,
              VAT: product.VAT,
              unit: product.unit,
              quantity: totals.duration,
              type: 'simple_line',
              shouldRecompute: true
            })]
            if (travel) {
              lines.push(this.invoiceLineManager.create({
                product: _.get(productTravel, '_id'),
                label: _.get(productTravel, 'label', 'Déplacement'),
                reference: _.get(productTravel, 'reference'),
                description: _.get(productTravel, 'description'),
                price: _.get(productTravel, 'price'),
                VAT: _.get(productTravel, 'VAT'),
                unit: _.get(productTravel, 'unit'),
                quantity: totals.travel,
                type: 'simple_line',
                shouldRecompute: true
              }))
            }
          }
        }
        if (stocks) {
          stocks.forEach((s) => {
            lines.push(this.invoiceLineManager.create({
              product: _.get(s, 'stock.product._id'),
              label: _.get(s, 'stock.product.label'),
              reference: _.get(s, 'stock.product.reference'),
              description: _.get(s, 'stock.product.description'),
              price: _.get(s, 'stock.product.price'),
              VAT: _.get(s, 'stock.product.VAT'),
              unit: _.get(s, 'stock.product.unit'),
              quantity: _.get(s, 'quantity'),
              type: 'simple_line',
              shouldRecompute: true
            }))
          })
        }

        this.account({ $lines: lines })
      })
    }

    // PRIVATES
    _switchApp () {
      return this.tokenSwitcherService.switchApp('solitech')
    }

    _loadInterventions (interventions = []) {
      // Ensure we have a string array
      const mapped = interventions.map((v) => {
        if (typeof v === 'string') {
          return v
        }
        return v._id
      })
      this.loading = true
      // Reset selections
      this.allStocks = []
      this.interventionSelection.reset()
      this.stockSelection.reset()
      let promise
      if (!interventions.length) {
        promise = this.$q.resolve({ data: [] })
      } else {
        const query = this.interventionManager.query({
          archived: 'both',
          populate: JSON.stringify([
            {
              path: 'linkedData.lifo.stockOut.stock',
              populate: [{ path: 'product' }]
            }
          ])
        }).select(mapped)
        promise = this.interventionManager.post(query)
      }
      return promise
        .then(({ data }) => {
          this.data = data.map((inter) => {
            inter.stocks = _.get(inter, 'linkedData.lifo.stockOut', []).map((stock) => {
              stock.intervention = inter._id
              this.allStocks.push(stock)
              return stock
            })
            return inter
          })
        }).finally(() => {
          this.loading = false
        })
    }
  }

  LinkInterventionController.$inject = [
    // Angular
    '$q', '$state',
    // Libs
    '$uibModal',
    // Managers
    'InterventionManager', 'InvoiceLineManager',
    // Services
    'DisplayService', 'SelectionService', 'TokenSwitcherService',
    // Const
    'urls'
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('linkIntervention', {
      bindings: {
        alreadyExist: '=?',
        interventions: '<',
        disabled: '=',
        isValidator: '=',
        remove: '&',
        account: '&',
        createIntervention: '&?'
      },
      controller: LinkInterventionController,
      templateUrl: '/app/common/components/link-intervention/link-intervention.template.html'
    })
})(window.angular, window._)
